(function() {
    'use strict';
    angular.module('app')
        .controller('ServiceBySpendController', function($scope, $routeParams, ReportingServiceBySpendTableService, $location) {
            $scope.params = $routeParams;
            $scope.ServiceBySpendTableData = ReportingServiceBySpendTableService;
            $scope.goTo = goTo;
            $scope.carrierName = $scope.params.carrierName;
            $scope.carrierId = $scope.params.carrierId;

            function goTo(path, params){
            	$location.path(path).search(params);
            }
        });
})();



// WEBPACK FOOTER //
// ./js/controllers/reporting/ServiceBySpendController.js